var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};


(function ($) { 
    var updatedWidgets = {};
    var updatedWidgetGroups = {};
    
    var updateWidgetAlertDiv = $('#updateWidgetAlert');

    $.extend(MDB.Charts, {
        showWidgetUpdateAlert: function () {
            updateWidgetAlertDiv.show();

        },
        hideWidgetUpdateAlert: function () {
            updateWidgetAlertDiv.hide();
        },
        widgetUpdateNoClick: function()  {
            MDB.Charts.hideWidgetUpdateAlert();
            location.reload();
        },
        widgetUpdateYesClick: function () {
            MDB.Charts.hideWidgetUpdateAlert();

            $.when.apply($, updateCachedWidgetsAndGroups()).done(function () {
                location.reload();
            });
        },
        cacheWidget: function (widget) {
            updatedWidgets[widget[0].id] = widget; 
        },
        cacheWidgetGroup: function(widgetGroup){
            updatedWidgetGroups[widgetGroup[0].id] = widgetGroup;
        }
    });
    
    function updateCachedWidgetsAndGroups(){
        var proms = [];
        
        //IE does not support Object.values :(
        var objectValues = Object.values || _.values;
        
        //Take all widgets -> Filter undefined/null values
        var widgets = objectValues(updatedWidgets)
            .filter(function(w) { return !!w; });
        
        var widgetGroups = objectValues(updatedWidgetGroups)
            .filter(function(w) { return !!w; });
        
        widgets.forEach(function(widget){ proms.push(updateWidget(widget)); });
        widgetGroups.forEach(function(widgetGroup) { proms.push(updateWidgetGroup(widgetGroup)); });
        
        return proms;
    }
    
    function updateWidgetGroup(widgetGroup){
        return MDB.Charts.storeWidgetGroupUpdatedPositionFromDOM(widgetGroup);
    }
    
    function updateWidget(widget){
        return MDB.Charts.storeUpdatedPositionFromDOM(widget);
    }
})(jQuery, window);